import Creator from "./Creator";

class Handlers {
    private handlers = [];

    public add(handler: (...args: any[]) => void): void {
        this.handlers.push(handler);
    }

    public dispatch(...arg: any[]): any {
        let args = arguments;
        let This = this;

        let result = null;

        $.each(this.handlers, function () {
            result = this.apply(This, args);

            if (result != null) {
                return false;
            }
        });

        return result;
    }
}

export default class Pager {
    private creator: Creator;

    private h_valid: Handlers = new Handlers();
    private h_change: Handlers = new Handlers();

    private $navibtns: JQuery;
    private $xpages: JQuery;
    private $prev: JQuery;
    private $next: JQuery;
    private $t1: JQuery;
    private $t2: JQuery;

    private sel: number = null;
    private visible: any = [];

    public constructor(creator: Creator) {
        this.creator = creator;

        this.$navibtns = null;
        this.$xpages = $('.xpage', this.creator.$xbody);
        this.$prev = $('.xnavi .prev', this.creator.$el);
        this.$next = $('.xnavi .next', this.creator.$el);
        this.$t1 = $('.js-creator-step');
        this.$t2 = $('.vcreator__stepinfo-title2', this.creator.$el);

        this.initHtml();
    }

    private getVisiblePages(): JQuery {
        let $pages = $();
        let $xpages = this.$xpages;

        $.each(this.visible, (ix, visible) => {
            if (visible) {
                let $xpage = $xpages.eq(parseInt(ix));
                $pages = $pages.add($xpage);
            }
        });

        return $pages;
    }

    public getCount(): number {
        return this.getVisiblePages().length;
    }

    public getPage(): JQuery {
        return this.getVisiblePages().eq(this.sel);
    }

    public getIndex(): number {
        return this.sel;
    }

    public isPageAddons(): boolean {
        return this.getIndex() == this.getCount() - 3;
    }

    public onChange(callback: (ix: number) => void): void {
        this.h_change.add(callback);
    }

    public onValidate(callback: (ix: number, $xpage: JQuery) => void): void {
        this.h_valid.add(callback);
    }

    public isValid(ix: number, skips?: boolean): boolean {
        let pages = this.getCount();

        if (ix < 0 || ix >= pages) {
            return false;
        }

        if (!skips) {
            for (let i = 0; i < ix; i++) {
                if (!this.isValid(i, true)) {
                    return false;
                }
            }
        }

        let result = this.h_valid.dispatch(ix, this.$xpages.eq(ix));

        if (result == undefined) {
            result = true;
        }

        return result;
    }

    public setVisible(ix: number, visible: boolean): void {
        this.visible[ix] = visible;

        let $xpage = this.$xpages.eq(ix);

        if (visible) {
            $xpage.show();
        } else {
            $xpage.hide();
        }

        this.updateLayout();
    }

    public updateLayout(): void {
        let ix = this.getIndex();
        let $page = this.getPage();

        this.rebuildNavi();

        let $pages = this.getVisiblePages();

        $pages.hide();
        $pages.removeClass('selected');

        $page.show();
        $page.addClass('selected');

        this.$prev.toggleClass('disabled', !this.isValid(ix - 1));
        this.$next.toggleClass('disabled', !this.isValid(ix + 1));

        this.$navibtns.each(function(i, el) {
            let $el = $(el);

            $el.toggleClass('focused', i <= ix);
            $el.toggleClass('selected', i == ix);
        });

        let six = (ix + 1).toString();

        if (six.length == 1) {
            six = '0' + six;
        }

        this.$t1.text(six);
        this.$t2.text($page.data('title'));

        let count = this.getCount();

        const $xbody = this.creator.$el;

        for (let i = 0; i < count; i++) {
            $xbody.removeClass('xbody--' + i)
        }

        $xbody.removeClass('xbody--last')

        if (ix != null) {
            $xbody.addClass('xbody--' + ix);

            if (ix == count - 1) {
                $xbody.addClass('xbody--last');
            }
        }
    }

    public switchTo(ix: number): void {
        if (!this.isValid(ix)) {
            return;
        }

        this.sel = ix;

        this.updateLayout();

        this.h_change.dispatch(ix);
    }

    public next(): void {
        this.switchTo(this.getIndex() + 1);
    }

    public prev(): void {
        this.switchTo(this.getIndex() - 1);
    }

    private rebuildNavi(): void {
        let This = this;

        let $navi = $('.vcreator__navi-pages', this.creator.$el);

        $navi.empty();

        for (let ix = 0; ix < this.getCount(); ix++) {
            $navi.append('<span>');
        }

        this.$navibtns = $('span', $navi);

        this.$navibtns.click(function (e) {
            e.preventDefault();

            This.switchTo($(this).index());
        });
    }

    private initHtml(): void {
        this.$xpages.each((ix) => {
            this.visible[ix] = true;
        });

        this.$prev.click((e) => {
            e.preventDefault();

            this.prev();
        });

        this.$next.click((e) => {
            e.preventDefault();

            this.next();
        });

        this.updateLayout();
    }
}
